import { Stack } from '@backyard-ui/core'

import { SelectOption } from '../SelectOption'
import {
  ContactSelectorOptionsType,
  ContactSelectorType
} from '../../MarketPlace/types'

interface SelectContactOptionsGroupProps {
  options: ContactSelectorOptionsType
  selected: 'email' | 'phone' | 'whatsapp' | ''
  onClick: (option: ContactSelectorType) => void
}

const SelectContactOptionsGroup = (
  props: Readonly<SelectContactOptionsGroupProps>
) => {
  const { options, onClick, selected } = props
  return (
    <Stack direction="column" className="w-fit inline rounded-lg">
      {options.map((option, index) => (
        <SelectOption
          key={option.key}
          label={option.label}
          isSelected={option.key === selected}
          isDisabled={!!selected}
          onSelect={() => onClick(option)}
          isFirst={index === 0}
          isLast={index === options.length - 1}
        />
      ))}
    </Stack>
  )
}
export default SelectContactOptionsGroup
